import React, {memo} from "react";
import {Link}  from "react-scroll";
import HoverAbleWord from "./layout/HoverAbleWord";
function Header()
{
    return (
        <header id={`header`} style={{backgroundImage: `url(https://ik.imagekit.io/omarkhaled/My_Portfolio/header-bg_XbQ3Ode4rz.webp?ik-sdk-version=javascript-1.4.3&updatedAt=1647622185363)`}} className={`h-screen`}>
            <div className="overlay">
                <div className="h-full select-none flex items-center flex-col justify-center gap-4">
                    <h1 className={`md:text-3xl text-center text-2xl font-bold text-white after-line-fade-in-out relative`}><HoverAbleWord word={`Hello, My name is Omar Khaled`} /><br /><HoverAbleWord word={`And I'm Full-stack web developer`} /></h1>
                    <div className="flex gap-4">
                        <Link to="Contact"
                            smooth={true}
                            offset={-50}
                            duration={500}
                            className="btn btn-primary btn-sm ">Contact</Link>
                        <Link to="about"
                            smooth={true}
                            offset={-50}
                            duration={500}
                            className="btn btn-primary btn-sm ">About</Link>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default memo(Header)